import { WithCompanyId } from '@mews-commander/types';
import { LocalizedSectionTitle, FieldsContainer } from '@mews-commander/ui';
import { TextKey } from '@mews-commander/enums';
import { LegalEntityIdentifiersFields } from '@mews-commander/legacy-form';
import { CompanyContactInfoFields } from './CompanyContactInfoFields';
import { CompanyFiscalFields } from './CompanyFiscalFields';

export interface ContactFieldsProps extends WithCompanyId {
    form: string;
}

const ContactFields = ({ form, companyId }: ContactFieldsProps) => (
    <FieldsContainer>
        <CompanyContactInfoFields form={form} companyId={companyId} />
        <LocalizedSectionTitle textKey={TextKey.Fiscal} />
        <CompanyFiscalFields />
        <LegalEntityIdentifiersFields form={form} />
    </FieldsContainer>
);

export default ContactFields;
